export const groupCode = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    name: { en: 'Name', ko: '이름', fr: '' },
    code: { en: 'Code', ko: '코드', fr: '' },
    description: { en: 'Description', ko: '비고', fr: '' },
  },
  info: {
    name: { en: 'Name', ko: '이름', fr: '' },
    code: { en: 'Code', ko: '코드', fr: '' },
    description: { en: 'Description', ko: '비고', fr: '' },
  },
};
